<template>
  <vueMultiselect
      :value="selection"
      :options="currencyOptions"
      :searchable="true"
      :show-labels="false"
      :allow-empty="true"
      :custom-label="currencyOptionLabel"
      :disabled="!editable"
      @select="(data) => currencySelected(data, company)"
      @close="closeSelection"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      {{ currencyOptionLabel(option) }}
    </template>
  </vueMultiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  props: {
    selectedPayment: {
      required: true,
    },
    company: {
      required: false,
    },
    editable: {
      required: false,
      default: true,
    }
  },

  components: {
    vueMultiselect: Multiselect,
  },

  data () {
    return {
      selection: this.selectedPayment,
    };
  },

  watch: {
    selectedPayment () {
      this.selection = this.selectedPayment;
    },
  },

  computed: {
    currencyOptions () {
      return this.$store.state.currencyOptions;
    },
  },

  methods: {
    currencyOptionLabel ({ country_name, currency_code }) {
      return currency_code && country_name ? `${country_name} - (${currency_code})` : 'N/A';
    },

    currencySelected (data, company) {
      this.selection = data;
      this.$emit('selected', data, company);
    },

    closeSelection (data) {
      if (this.selection === data) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
